import { render } from "./RetailerDetails.vue?vue&type=template&id=700cc1eb"
import script from "./RetailerDetails.vue?vue&type=script&lang=js"
export * from "./RetailerDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__